export const formatCurrency = (v, currency = "COP") => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(num)
}

export const formatNumber = (v, decimals = 0) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num)
}

// Cantidades/unidades: muestra decimales SOLO si existen (no redondea a
// entero). Necesario para ventas por peso (kg). Enteros se ven igual.
export const formatCantidad = (v, maxDecimals = 3) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxDecimals,
  }).format(num)
}

export const formatPercent = (v, decimals = 2) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return `${num.toFixed(decimals)}%`
}

export const formatGrowth = v => {
  const num = Number(v)
  if (!isFinite(num)) return { text: "—", color: "#64748b", icon: "minus" }
  const text = `${num > 0 ? "+" : ""}${num.toFixed(2)}%`
  if (num > 0) return { text, color: "#10b981", icon: "trending-up" }
  if (num < 0) return { text, color: "#ef4444", icon: "trending-down" }
  return { text, color: "#64748b", icon: "minus" }
}

// Paleta para gráficos / pie charts
export const PALETA = [
  "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
  "#ec4899", "#06b6d4", "#84cc16", "#f97316", "#6366f1",
  "#14b8a6", "#eab308", "#a855f7", "#22c55e", "#0ea5e9",
]

export const colorPara = i => PALETA[i % PALETA.length]
